<template>
  <div>
    <ob-modal2 :show.sync="show" :backdrop="false" width="900px">
      <template v-if="$route.query.from != 'employer-timesheets'" slot="modal-title">
        Evaluation Report
        <span
          style="font-size: 12px;padding-right: 10px;color:#8595A6;"
        >Start Date: {{NAOrValue(selectedReport,'FromDate')}}</span>|
        <span
          style="padding-left: 10px;font-size: 12px;color:#8595A6;"
        >End Date:{{NAOrValue(selectedReport,'ToDate')}}</span>
      </template>
      <template v-else slot="modal-title">
        Evaluation Report
        <span
          style="font-size: 12px;padding-right: 10px;color:#8595A6;"
        >Start Date: {{TimeSheetdateFrom}}</span>|
        <span
          style="padding-left: 10px;font-size: 12px;color:#8595A6;"
        >End Date:{{TimeSheetdateTo}}</span>
      </template>
      <template slot="modal-body">
        <div class="form-group row">
          <div class="col-md-12">
            <h5
              style="font-weight:600;font-size:13px;"
            >Evaluate the performance of your employee using the below parameters. You can also add a new parameter (or) Select a template.</h5>
          </div>
        </div>
        <div class="form-group row">
          <div style="padding-left: 30px;" class="col-md-4">
             <div class="radio-inline pL0"><ob-radio v-if="show" name="options" val="UserTemplate" v-model="evalutionOption">Use Template</ob-radio></div>
             <div class="radio-inline pL0"><ob-radio v-if="show" name="options" val="ManualTemplate" v-model="evalutionOption">Manual Evaluation</ob-radio></div>
          </div>
        </div>
        <div v-if="evalutionOption =='UserTemplate'" class="form-group row">
          <div style="padding-left: 30px;" class="col-md-4">
            <label>Select Evaluation Template </label><span class="validation-star">*</span>
              <br>
             <ob-select2 :inModal ="true" v-if="showEvalutionOptions" v-model.trim="selectedEvalution" @input="onEvalutionSelect(selectedEvalution)" :options="evalutionOptions"></ob-select2>
             <span class="ob-vuelidate_error-msg" v-if="isValid">Select evaluation template</span>
          </div>
        </div>
        <div class="evaluation_report">
          <div class="form-group row">
            <div class="col-md-12">
              <div class="col-md-6" v-for="(list,index) in evaluation" :key="index">
                <div class="col-md-12">
                  <div class="col-md-8" style="margin-left:-30px;">
                    <label>{{list.Title}}</label>
                  </div>
                  <div class="col-md-4 rate">
                    <rating
                      v-model="list.Rating"
                      :increment="0.5"
                      :star-size="15"
                      :border-width="2"
                      border-color="#d8d8d8"
                      :rounded-corners="true"
                      :star-points="[23,2, 14,17, 0,19, 10,34, 7,50, 23,43, 38,50, 36,34, 46,19, 31,17]"
                    ></rating>
                  </div>
                </div>
                <ob-textarea :maxLength="1200" v-model="list.Comment"></ob-textarea>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div v-for="(report,Index) in evaluationReport" :key="Index">
            <div
              class="col-md-12"
              style="margin-top:20px;border-top:1.5px dashed rgb(212, 204, 204)"
            >
              <div class="col-md-6" style="margin-bottom:20px;margin-top:10px;">
                <label>Title</label>
                <ob-input v-model="report.Title"></ob-input>
              </div>
              <div class="col-md-3" style="margin-top:10px;">
                <label>Rating</label>
                <rating
                  v-model="report.Rating"
                  :increment="0.5"
                  :star-size="15"
                  :border-width="2"
                  border-color="#d8d8d8"
                  :rounded-corners="true"
                  :star-points="[23,2, 14,17, 0,19, 10,34, 7,50, 23,43, 38,50, 36,34, 46,19, 31,17]"
                ></rating>
              </div>
              <div class="col-md-3" style="margin-top:20px;">
                <span
                  @click="onRemove(Index)"
                  style="margin-left:20px;color: #DD3D64; font-size: 12px;font-weight: 600;cursor: pointer;"
                >Remove</span>
              </div>
            </div>
            <div class="col-md-6" style="margin-left:20px;">
              <label>Description</label>
              <ob-textarea  :maxLength="1200" v-model="report.Comment"></ob-textarea>
            </div>
          </div>
        </div>
        <div
          class="form-group row"
          style="margin-left: 2px;margin-bottom:0px;margin-top:6px;border-top:1.5px dashed rgb(212, 204, 204)"
        >
          <div class="col-md-12 add_task" style="margin-top:10px;">
            <a @click="addParameter(evaluationReport)">
              <img :src="`${CDNIMAGESBASEURL}/ess/ESSApp/static/Images/ic_add.svg`" />
              <span style="color:#464444;font-weight: 600;">Add a Parameter</span>
            </a>
          </div>
        </div>
      </template>
      <template slot="modal-footer">
        <ob-button type="secondary" @click="goBack()">Back</ob-button>
        <ob-button @click="approve()">Evaluate</ob-button>
      </template>
    </ob-modal2>
  </div>
</template>
<script>
import StarRating from "vue-star-rating";
export default {
  props: ["openModal", "selectedReport", "EvaluationStatus","TimeSheetdateFrom","TimeSheetdateTo","selectedEmployee","ApprovedTimeSheetId"],
  data() {
    return {
      tempEvalution : [],
      evalutionTempOption:"",
      tempSelectedEvalution:"",
      isValid:false,
      evalutionList :[],
      showEvalutionOptions : true,
      selectedEvalution:"",
      evalutionOption : "ManualTemplate",
      show: false,
      evaluationReport: [],
      openRejectPopup: false,
      evalutionOptions:{
                placeholder: {
                id: "-1",
                text: "Select Evaluation Template"
              },
            data: [

            ]
          },
      evaluation: [
        {
          Title: "Quantity of Work",
          Rating: 0,
          Comment: ""
        },
        {
          Title: "Quality of Work",
          Rating: 0,
          Comment: ""
        },
        {
          Title: "Punctuality of Work",
          Rating: 0,
          Comment: ""
        },
        {
          Title: "Initiative, Creativity, and Judgement",
          Rating: 0,
          Comment: ""
        },
        {
          Title: "Commitment to Program Goals",
          Rating: 0,
          Comment: ""
        },
        {
          Title: "Ability to work with others",
          Rating: 0,
          Comment: ""
        },
        {
          Title: "Ability to Solve Problems",
          Rating: 0,
          Comment: ""
        },
        {
          Title: "Professional Skills in Present Activity",
          Rating: 0,
          Comment: ""
        }
      ]
    };
  },
  components: {
    rating: StarRating
  },
  created() {
    this.show = this.openModal;
  },
  watch: {
    openModal(val) {
       this.show = val;
       this.evalutionOption = "ManualTemplate"
       this.getEvalutiontemplateList()
    },
    show(val) {
      this.$emit("update:openModal", val);
    },
    evalutionOption(val){
      if(val == this.evalutionTempOption && this.EvaluationStatus == "Approved"){
        this.evaluation = this.tempEvalution
        this.selectedEvalution = this.tempSelectedEvalution
      }
      else{
        this.resetValues();
        this.selectedEvalution = ""
        this.isValid = false
      }
    },
  },
  computed: {
    TimeSheetId() {
      if(this.$route.name  == "timesheets-list")
      {
         return this.selectedReport.TimesheetId;
      }
      return this.selectedReport.Id;
    }
  },
  methods: {
    onEvalutionSelect(val){
        this.resetValues();
        let list = this.evalutionList.filter(item => item.Id == val);
        this.evaluation = list[0].RatingList
        this.isTempleteSelected()
    },
    getEvalutiontemplateList(){
     this.showEvalutionOptions = false;
      this.$loading({loadingText: 'Please wait...'});
      ajax.get(`TimesheetEvaluations/AllList?orgId=${this.loggedInUserObj.orgId}`, {}, (res) => {
          if(res.data.State == true){
             this.resetValues();
            if (this.EvaluationStatus == "Approved") {
                this.getApprovalData();
            }
            console.log("res",res.data)
              this.evalutionList = res.data.TimesheetEvaluations
              this.evalutionOptions.data = __.map(this.evalutionList, (t) => {
                  return {
                  'id': t.Id,
                  'text': t.EvaluationTitle
                  }
              })
          }
           this.showEvalutionOptions = true
          this.$loading({}).close()
        })
      },
    resetValues() {
      var evaluation = [
        {
          Title: "Quantity of Work",
          Rating: 0,
          Comment: ""
        },
        {
          Title: "Quality of Work",
          Rating: 0,
          Comment: ""
        },
        {
          Title: "Punctuality of Work",
          Rating: 0,
          Comment: ""
        },
        {
          Title: "Initiative, Creativity, and Judgement",
          Rating: 0,
          Comment: ""
        },
        {
          Title: "Commitment to Program Goals",
          Rating: 0,
          Comment: ""
        },
        {
          Title: "Ability to work with others",
          Rating: 0,
          Comment: ""
        },
        {
          Title: "Ability to Solve Problems",
          Rating: 0,
          Comment: ""
        },
        {
          Title: "Professional Skills in Present Activity",
          Rating: 0,
          Comment: ""
        }
      ];
      this.evaluation = evaluation;
      this.evaluationReport = [];
    },
    isTempleteSelected(){
        if(this.selectedEvalution == "" && this.evalutionOption == "UserTemplate"){
          this.isValid = true
        }
        else{
          this.isValid = false
        }
    },
    approve() { 
      this.isTempleteSelected()
      if(this.isValid == false){
      this.openRejectPopup = false;
      var ratingObj = this.evaluation.concat(this.evaluationReport);
      var Obj ={}
      if(this.$route.query.from == 'employer-timesheets'){
            Obj = {
            EmployeeId: this.selectedEmployee,
            TimeSheetId:this.ApprovedTimeSheetId,
            IsEvaluate: true,
            EvaluateTemplateId : this.selectedEvalution,
            EvaluationTemplateType : this.evalutionOption,
            RatingList: ratingObj,
            Id : this.selectedReport != null && this.selectedReport != undefined ? this.selectedReport.Id :''

        }
      }
      else{
        var empId = this.selectedReport.EmployeeId;
         Obj = {
          EmployeeId: empId,
          TimeSheetId: this.selectedReport.TimesheetId,
          IsEvaluate: true,
          EvaluateTemplateId :this.selectedEvalution,
          EvaluationTemplateType : this.evalutionOption,
          RatingList: ratingObj,
          Id : this.selectedReport != null && this.selectedReport != undefined ? this.selectedReport.Id :''
        };
      }
      if (this.$route.name == "employer-timesheets" || this.$route.name == "timesheets-list") {
        this.$parent.$parent.sendForApproval(Obj);
      } else {
        this.$loading({ loadingText: "Loading..." });
        ajax.post(`/TimeSheets/Evaluate`, Obj, res => {
          if (res.data.State == true) {
            if(this.$route.query.from == 'employer-timesheets' || this.$route.name == "timesheets-list"){
              this.$message({
                      type: "success",
                      message: "Timesheet approved & evaluated successfully"
                  });
                }
              else{
                this.$message({
                  type: "success",
                  message: "Timesheet evaluated successfully"
                });
              }
          } else {
            this.$message({
              type: "error",
              message: res.data.Message
            });
          }
          if(this.$route.query.from == 'employer-timesheets' || this.$route.name == "timesheets-list"){
            this.show = false;
            this.$loading({}).close();
            if(this.$route.query.listView)
            {
                this.$router.push({'path': '/timesheets-list', query: { listView: "true" }})
            }
            else
            {
              this.$router.push({ name: "employer-timesheets" });
            }
          }
          else{
            this.show = false;
            this.$parent.getEvaluation();
            this.$loading({}).close();
          }
        });
      }
     }
    },
    getApprovalData() {
      this.$loading({ loadingText: "Loading..." });
      ajax.get(
        `TimeSheets/GetEvaluationReport?id=${this.TimeSheetId}`,
        {},
        res => {
          if (res.data.State == true) {
            this.tempEvalution = res.data.EvaluationRatingList
            this.evaluation = res.data.EvaluationRatingList;
            this.evalutionOption = res.data.EvaluationTemplateType
            this.evalutionTempOption =  res.data.EvaluationTemplateType
            this.selectedEvalution = res.data.EvaluationTemplateId
            this.tempSelectedEvalution = res.data.EvaluationTemplateId
          }
          this.$loading({}).close();
        }
      );
    },
    goBack() {
      if (this.$route.name == "employer-timesheets") {
        this.$parent.$parent.OnEvaluationRatingPopupClased();
      }
      else if(this.$route.query.from == 'employer-timesheets'){
        this.$parent.$parent.$parent.OnEvaluationRatingPopupClosed();
      }
      else {
        this.show = false;
      }
    },
    addParameter(details) {
      details.push({
        Title: "",
        Comment: "",
        Rating: 0
      });
    },
    onRemove(details) {
      this.evaluationReport.splice(details, 1);
    }
  }
};
</script>
<style>
.rate {
  float: right;
  margin-right: -10px;
}
</style>



// WEBPACK FOOTER //
// src/components/ESSProfile/Timesheets/EvaluationReport.vue